import type { UseFormReturn } from 'react-hook-form';

import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Field, Textarea } from '~/components/Form';

type FormWithDescription = {
  description: string;
};

type Props<T extends FormWithDescription> = {
  form: T extends FormWithDescription ? UseFormReturn<T> : never;
};

export const FormDescription = <T extends FormWithDescription>({ form: { control } }: Props<T>) => {
  const { t } = useTranslation(['invoices', 'validation']);

  return (
    <Controller
      control={control}
      name="description"
      render={({ field: { name, onBlur, onChange, ref, value }, fieldState: { error, invalid, isDirty, isTouched } }) => (
        <Field.Root dirty={isDirty} invalid={invalid} name={name} touched={isTouched}>
          <Field.Label optional>{t('invoices:fields.description.label')}</Field.Label>

          <Textarea
            onBlur={onBlur}
            onValueChange={onChange}
            placeholder={t('invoices:fields.description.placeholder')}
            ref={ref}
            value={value}
          />

          <Field.Error match={!!error}>{error?.message}</Field.Error>
        </Field.Root>
      )}
      rules={{
        maxLength: {
          value: 2000,
          message: t('validation:maxLength', { attribute: t('invoices:fields.description.label'), max: 2000 }),
        },
      }}
    />
  );
};
